<script setup lang="ts">
const {
  shadow = 'md',
  color,
  actionsJustify = 'end',
  size = 'md',
} = defineProps<{
  shadow?: 'none' | 'sm' | 'md' | 'lg' | 'xl'
  size?: 'none' | 'sm' | 'md' | 'lg' | 'xl'
  color?: string
  actionsJustify?: 'start' | 'end' | 'center'
}>()

const shadowMap = {
  none: '',
  sm: 'shadow-sm',
  md: 'shadow-md',
  lg: 'shadow-lg',
  xl: 'shadow-xl',
}

const sizeMap = {
  none: 'p-0',
  sm: 'card-sm',
  md: 'card-md',
  lg: 'card-lg',
  xl: 'card-xl',
}

const cardClass = computed(() => {
  const backgroundColor = color ? `bg-${color}` : 'bg-base-100'
  const textColor = color ? `text-${color}-content` : ''
  return `${backgroundColor} ${textColor} ${shadowMap[shadow]} ${sizeMap[size]}`
})
</script>

<template>
  <div class="card rounded-xl" :class="cardClass">
    <div class="card-body" :class="{ 'p-0': size === 'none' }">
      <div v-if="$slots.title" class="card-title">
        <slot name="title" />
      </div>
      <slot name="content" />
      <div
        v-if="$slots.actions"
        class="card-actions"
        :class="`justify-${actionsJustify}`"
      >
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>
